import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./router/Routes";
import "./themes/css/list-view.css";
import "./themes/css/railways-login.css";
import App from "./App";

// ReactDOM.render(Routes, document.getElementById("root"));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA



import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./components/Authentication";

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </Router>
    </React.StrictMode>,
    document.getElementById("root")
);
serviceWorker.unregister();